import type { FC } from 'react';

import { useTranslation } from '@mopla/i18';

import { MplButton } from '../../../atoms/MplButton/MplButton';
import { MplModal } from '../../MplModal/MplModal';

export interface SchoolConfirmationModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	isCanceling: boolean;
}

/**
 * Confirm-only modal for cancelling a school (RMBLS / SPECIAL_SCHOOL_TRAFFIC)
 * ride. These rides skip the reason form entirely and are cancelled with the
 * OTHER_REASON reason.
 */
export const SchoolConfirmationModal: FC<SchoolConfirmationModalProps> = ({
	open,
	onClose,
	onConfirm,
	isCanceling,
}) => {
	const { t } = useTranslation('tickets');

	return (
		<MplModal
			open={open}
			testId="SchoolConfirmationModal-MplModal"
			onBackDropClick={onClose}
			title={t('school_cancellation.confirm_title')}
			content={t('school_cancellation.confirm_description')}
			buttons={
				<>
					<MplButton
						fullWidth
						variant="outlined"
						onClick={onClose}
						disabled={isCanceling}
						testId="SchoolConfirmationModal-AbortButton"
					>
						{t('button.abort', { context: 'ride' })}
					</MplButton>
					<MplButton
						fullWidth
						onClick={onConfirm}
						showLoader={isCanceling}
						disabled={isCanceling}
						testId="SchoolConfirmationModal-ConfirmButton"
					>
						{t('button.confirm_cancel', { context: 'ride' })}
					</MplButton>
				</>
			}
		/>
	);
};
